import React, { useContext, useMemo } from 'react';

import CarrierInsurancePanel from '../components/panels/CarrierInsurancePanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierInsurancePage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  if (!selectedCarrier) {
    return null;
  }

  if (!userHasPermission(selectedCarrier, 'insurancePermission')) {
    return null;
  }

  return (
    <Layout
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      <CarrierInsurancePanel
        carrier={selectedCarrier}
        id="insurance"
        userRole={authUser?.role}
      />
    </Layout>
  );
};

export default CarrierInsurancePage;
